import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import POSAction from "../stores/actions/POSAction";
import { RootState } from "../stores";
import { toast } from "react-toastify";

function ProductModel({
  productModal,
  setProductModal,
  productId,
  slug,
  userId,
  getCartDataList,
}: any) {
  const handleClose = () => setProductModal(false);
  const dispatch = useDispatch<any>();
  const [productLoader, setProductLoader] = useState(false);

  const { productDetails } = useSelector((state: RootState) => state.pos);
  const [selectedSize, setSelectedSize] = useState("");
  const [selectedColor, setSelectedColor] = useState("");
  const [stockAvailability, setStockAvailability] = useState(false);
  const [type, setType] = useState("");

  console.log({ productDetails });

  const productDetailsFetch = useCallback(async () => {
    setProductLoader(true);
    try {
      if (type === "variants") {
        await dispatch(
          POSAction.getProductVariantDetails({
            product_id: productId,
            size: selectedSize,
            color: selectedColor,
          })
        );
      } else {
        await dispatch(
          POSAction.getProductDetails({
            slug: slug,
            product_id: productId,
          })
        );
      }
      setProductLoader(false);
    } catch (error) {
      setProductLoader(false);
    }
  }, [type, dispatch, productId, slug, selectedSize, selectedColor]);

  useEffect(() => {
    if (productDetails?.selectedSize) {
      setSelectedSize(productDetails.selectedSize);
    }
    if (productDetails?.selectedColor) {
      setSelectedColor(productDetails.selectedColor);
    }
    if (productDetails.product_available) {
      setStockAvailability(true);
    } else {
      setStockAvailability(false);
    }
  }, [
    productDetails.selectedSize,
    productDetails.selectedColor,
    productDetails.product_available,
  ]);

  useEffect(() => {
    productDetailsFetch();
  }, [productDetailsFetch]);

  const handleSubmit = async () => {
    if (!userId) {
      toast.error("Please select buyer");
    } else {
      try {
        await dispatch(
          POSAction.addCart({
            product_id: productId,
            size: selectedSize,
            color: selectedColor,
            user_id: userId,
            isVariant: productDetails.is_variant,
          })
        );
        toast.success("Added to Cart");
        getCartDataList();
      } catch (e: any) {
        toast.error(e.message);
      }
    }
  };

  // console.log(productDetails.is_variant);

  return (
    <div className="modal" style={{ display: productModal ? "block" : "none" }}>
      <div className="modal-dialog modal-lg" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Product Details</h5>
            <button
              type="button"
              className="btn-close"
              onClick={handleClose}></button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-md-6">
                <div className="images ">
                  <div className="text-center">
                    {productDetails?.product_image?.length > 0 ? (
                      <img
                        id="main-image"
                        src={productDetails?.product_image[0]?.product_image}
                        className="img-fluid"
                      />
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="product">
                  <div className="mb-3">
                    {" "}
                    <span className="text-uppercase text-muted brand">
                      {productDetails?.sellerName}
                    </span>
                    <h5 className="mt-1">{productDetails?.product_name}</h5>
                    <div className="price d-flex h5 flex-row align-items-center">
                      {" "}
                      <span className="act-price">
                        ₹ {productDetails.selling_price}
                      </span>
                      &nbsp;&nbsp;&nbsp;
                      <div className="ml-2">
                        {" "}
                        <small className="dis-price text-danger">
                          <s>₹ {productDetails.mrp}</s>
                        </small>{" "}
                        &nbsp;&nbsp;&nbsp;
                        <span className="text-success">
                          {productDetails.discount}% OFF
                        </span>{" "}
                      </div>
                    </div>
                  </div>
                  <p className="about">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: productDetails?.description,
                      }}
                    />
                  </p>
                  <div>
                    {productDetails?.color?.length > 0 ? (
                      <div className="mb-4 mt-2">
                        <div className={"flex items-center space-x-2"}>
                          <h6 className="text-uppercase mb-2">Color</h6>{" "}
                          <select
                            name=""
                            id=""
                            className="form-control"
                            onChange={(e) => setSelectedColor(e.target.value)}>
                            <option value="" selected disabled>
                              Select Colors
                            </option>
                            {productDetails?.color?.map(
                              (color: any, index: number) => {
                                return (
                                  <option
                                    key={index}
                                    value={color}
                                    selected={color === selectedColor}>
                                    {color}
                                  </option>
                                );
                              }
                            )}
                          </select>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  {productDetails?.size?.length > 0 ? (
                    <div className="sizes mt-2 pb-2 border-gray-300 dark:border-gray-700">
                      <div className={"flex items-center space-x-4"}>
                        <h6 className="text-uppercase mb-2">Size</h6>{" "}
                        <ul
                          className="d-flex items-center gap-3 p-0"
                          style={{ listStyle: "none" }}>
                          {productDetails?.size?.map((size: any, i: number) => {
                            return (
                              <li key={i}>
                                <button
                                  className={`px-3 btn btn-success ${
                                    size === selectedSize
                                      ? "bg-orange-400 text-white"
                                      : "bg-white text-black"
                                  }`}
                                  onClick={() => {
                                    setSelectedSize(size);
                                    setType("variants");
                                  }}>
                                  {size}
                                </button>
                              </li>
                            );
                          })}
                        </ul>
                      </div>
                    </div>
                  ) : null}
                </div>

                {!stockAvailability ? (
                  <div
                    className={
                      "border-2 border-red-400 rounded text-red-500 mt-2"
                    }>
                    This variant is not available yet.
                  </div>
                ) : null}

                <div className="cart align-items-center">
                  {" "}
                  <button
                    className="btn btn-danger text-uppercase mr-2 px-4"
                    onClick={handleSubmit}>
                    <i className="fa fa-shopping-cart text-white"></i>&nbsp; Add
                    to cart
                  </button>{" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductModel;
